import { MenuOptionType } from "@dexteel/mesf-core";
import { Delete, Replay } from "@mui/icons-material";
import { Cobble } from "../../models/Cobble";

type Props = {
	setShowModal: (show: "Delete" | "Undelete" | "") => void;
};

export const useCobbleOptionsFunctions = ({ setShowModal }: Props) => {
	const getMenuOptions = (data: Cobble | null) => {
		const options: MenuOptionType[] = [];

		if (!data) return options;

		if (data.IsCobble) {
			options.push({
				name: "Delete",
				key: "delete_cobble",
				onClick: () => setShowModal("Delete"),
				icon: <Delete fontSize="small" color="secondary" />,
			});
		} else {
			options.push({
				name: "Undelete",
				key: "undelete_cobble",
				onClick: () => setShowModal("Undelete"),
				icon: <Replay fontSize="small" color="primary" />,
			});
		}

		return options;
	};

	return { getMenuOptions };
};
